export const ALL_TABS = [
  'context',
  'tasks',
  'files',
  'notes',
  'claims',
  'artifacts',
] as const;

export type SegmentTab = (typeof ALL_TABS)[number];

export const SEGMENT_PARAM = 'tab';

const IS_TAB = (value: string): value is SegmentTab =>
  (ALL_TABS as readonly string[]).includes(value);

export function resolveTabs(tabs: string[] | undefined | null): SegmentTab[] {
  const allowed = (tabs ?? []).filter(IS_TAB);
  return allowed.length > 0 ? allowed : [...ALL_TABS];
}

export function defaultSegment(tabs: readonly SegmentTab[]): SegmentTab {
  return tabs.includes('context') ? 'context' : tabs[0];
}

export function parseSegment(
  searchParams: URLSearchParams,
  tabs: readonly SegmentTab[] = ALL_TABS
): SegmentTab {
  const value = searchParams.get(SEGMENT_PARAM);
  return value && IS_TAB(value) && tabs.includes(value)
    ? value
    : defaultSegment(tabs);
}
